export default __webpack_public_path__ + "27bbed20f6a5019ac68320f6380641f8.jpg";